/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { AverageContractPriceDto, DashboardAverageItem } from '@gh/builder-shared-data';

export type AverageContractPrice = AverageContractPriceDto;
export const averageContractPriceFromDto = (dto: AverageContractPriceDto): DashboardAverageItem[] => [
  {
    label: '',
    value: dto.contractPriceAvg,
    isMain: true,
    format: 'Price',
    prefix: '$',
  },
  {
    label: 'lbl_total_contracts',
    value: <any>(dto.contractCount || null),
    isMain: false,
    format: 'Quantity',
  },
  {
    label: 'lbl_total_contract_price',
    value: dto.contractPriceSum || null,
    isMain: false,
    format: 'Price',
  },
];
